/* @ngInject */
export function InputEquipmentIdController($ngRedux) {
    var ctrl = this;
    var unsubscribe = angular.noop;

    ctrl.$onInit = function() {
        unsubscribe = $ngRedux.connect(mapStateToThis, {})(this);
    };

    ctrl.onChange = function() {
        $ngRedux.dispatch({
            type: 'EQUIPMENT_ID_CHANGE',
            id: ctrl.identifier,
            equipmentId: ctrl.equipmentId
        });
    };

    ctrl.$onDestroy = function() {
        unsubscribe();
    };

    function mapStateToThis(state) {
        return {
            equipmentId: _.get(state, getStateContainer('filter.equipmentId'), null)
        };
    }

    function getStateContainer(statePath) {
        return [ctrl.module, ctrl.identifier].join('.') + '.' + statePath;
    }
}
